<script lang="ts" setup>
import useSharedStore from '@/presentation/store/shared';
import NavbarItem from '@/presentation/components/layouts/default/NavbarItem.vue';
import BaseImg from '@/presentation/components/base/image/BaseImg.vue';

const route = useRoute();
const routeName = computed(() => route.name);
const sharedStore = useSharedStore();
const userInformation = computed(() => sharedStore.userInformation);

const bottomNavbarItems = ref([
	{
		routeAddress: '/dashboard/admin',
		routeName: 'DashboardAdmin',
		label: 'داشبورد',
		iconName: 'setting',
		activeForRule: ['Admin'],
	},
	{
		routeAddress: '/setting',
		routeName: 'Setting',
		label: 'تنظیمات',
		iconName: 'setting',
		activeForRule: ['User', 'AllUser'],
	},
	{
		routeAddress: '/dashboard',
		routeName: 'Index',
		label: 'داشبورد',
		iconName: 'book',
		activeForRule: ['Business'],
	},
	{
		routeAddress: `/profile/${userInformation.value.userId}`,
		routeName: 'ProfileShopId',
		label: 'پروفایل',
		iconName: 'user',
		activeForRule: ['Business'],
		customRuleActivation: computed(() => route.params.shopId === userInformation.value.userId),
	},
	{
		routeAddress: '/requests',
		routeName: 'Request',
		label: 'درخواست ها',
		iconName: 'calendar',
		activeForRule: ['User', 'AllUser'],
	},
	{
		routeAddress: '/category',
		routeName: 'Category',
		label: 'دسته بندی ها',
		iconName: 'category',
		activeForRule: ['User', 'Admin', 'Business', 'AllUser'],
	},
	{
		routeAddress: '/home',
		routeName: 'Home',
		label: 'خانه',
		iconName: 'home',
		activeForRule: ['User', 'Admin', 'Business', 'AllUser'],
	},
]);

const invertedNavbarItems = bottomNavbarItems.value.reverse();

const isBusinessProfile = computed(() => route.name === 'profile-shopId' && userInformation.value.userId !== route.params.shopId);
</script>

<template>
	<div class="md:flex">
		<main class="md:pb-[4rem] md:mx-auto md:mr-[260px] md:py-11 md:pl-8 md:w-full md:bg-gray-300 md:bg-white md:min-h-screen">
			<slot />
		</main>
		<nav class="hidden md:flex flex-col fixed right-0 w-[260px] h-screen bg-white pb-10">
			<BaseImg src="/images/newty-logo.png" src-type="public" width="100" class="mx-auto" />
			<template v-for="item in invertedNavbarItems" :key="item.routeName">
				<NavbarItem
					v-if="item.activeForRule.includes(userInformation.role) && !isBusinessProfile"
					:label="item.label"
					:icon-name="item.iconName"
					:active-route-name="routeName"
					:route-name="item.routeName"
					:route-address="item.routeAddress"
					:custom-rule-activation="item.customRuleActivation"
				/>
			</template>
		</nav>
	</div>
</template>
